function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M497,60h-15V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v45h-30V15c0-8.284-6.716-15-15-15s-15,6.716-15,15v45h-15 c-8.284,0-15,6.716-15,15v60c0,24.813,20.187,45,45,45h15v195c0,8.271-6.729,15-15,15s-15-6.729-15-15v-90 c0-24.813-20.187-45-45-45h-15V45c0-24.813-20.187-45-45-45H75C50.187,0,30,20.187,30,45v379.58C12.541,430.772,0,447.445,0,467 v30c0,8.284,6.716,15,15,15h332c8.284,0,15-6.716,15-15v-30c0-19.555-12.541-36.228-30-42.42V270h15c8.271,0,15,6.729,15,15v90 c0,24.813,20.187,45,45,45s45-20.187,45-45V180h15c24.813,0,45-20.187,45-45V75C512,66.716,505.284,60,497,60z M60,45 c0-8.271,6.729-15,15-15h212c8.271,0,15,6.729,15,15v135H60V45z M60,210h242v212H60V210z M332,482H30v-15c0-8.271,6.729-15,15-15 h272c8.271,0,15,6.729,15,15V482z M482,135c0,8.271-6.729,15-15,15h-60c-8.271,0-15-6.729-15-15V90h90V135z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M223.76,307.114C221.026,302.692,216.198,300,211,300h-35.729l19.146-38.292c3.705-7.41,0.702-16.42-6.708-20.125 c-7.41-3.705-16.42-0.701-20.124,6.708l-30,60c-2.325,4.65-2.077,10.172,0.656,14.594c2.733,4.422,7.562,7.114,12.76,7.114h35.729 l-19.146,38.292c-3.705,7.41-0.702,16.42,6.708,20.125c7.423,3.712,16.427,0.687,20.124-6.708l30-60 C226.741,317.058,226.493,311.536,223.76,307.114z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M257,60H105c-8.284,0-15,6.716-15,15v60c0,8.284,6.716,15,15,15h152c8.284,0,15-6.716,15-15V75 C272,66.716,265.284,60,257,60z M242,120H120V90h122V120z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

function Svg24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/2_4.8f181add.svg";
export { ForwardRef as ReactComponent };